module.exports = __webpack_public_path__ + "img/malte_en_cover.2dd6f245.jpg";